module.exports = __webpack_public_path__ + "static/img/CgoRC2REg0GAZVZZAAXmwkIRbew163.bfa7eb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRC2REg0GAZVZZAAXmwkIRbew163.jpg
// module id = DOCO
// module chunks = 73